/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Project edges onto faces</h4>

<p>Project the selected edges, or the edges of any selected faces, onto any other faces.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('726057187')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function ProjectEdgesTooltip() {
    return h('div', { innerHTML: body });
}
